import $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable';

// While any drag is in progress on the dispatch board (a panel card, or a job
// being moved or resized on the calendar), refreshes wait: re-rendering the
// calendar or the panel mid-drag cuts the drag off. Queued work runs once,
// by key, when the last drag ends.
let activeDrags = 0;
const queued = new Map();

export function setDispatchDragging(isDragging) {
  activeDrags = Math.max(0, activeDrags + (isDragging ? 1 : -1));
  document.body.classList.toggle('dispatch-dragging', activeDrags > 0);
  if (activeDrags === 0 && queued.size) {
    const pending = [...queued.values()];
    queued.clear();
    pending.forEach((fn) => fn());
  }
}

export function whenNotDragging(key, fn) {
  if (activeDrags > 0) {
    queued.set(key, fn);
  } else {
    fn();
  }
}

// Make job cards in a side panel draggable onto the dispatch calendar
// (FullCalendar's `droppable` accepts `.fc-events`). Safe to call after every
// render: cards that are already draggable are skipped. The drag shows a copy
// on <body> so it isn't clipped by the panel's scrolling list.
export function makeJobCardsDraggable(container) {
  if (!container) return;
  $(container)
    .find('.fc-events:not(.ui-draggable)')
    .each(function () {
      $(this).draggable({
        zIndex: 9999999,
        revert: true,
        revertDuration: 0,
        helper: 'clone',
        appendTo: 'body',
        cursor: 'grabbing',
        start: function (event, ui) {
          this.dataset.dragging = '1';
          setDispatchDragging(true);
          ui.helper.addClass('usg-card--dragging').css('width', $(this).outerWidth());
        },
        // Releasing a drag also fires click; let click handlers skip it.
        stop: function () {
          setTimeout(() => { delete this.dataset.dragging; }, 0);
          // After FullCalendar has handled the drop.
          setTimeout(() => setDispatchDragging(false), 0);
        },
      });
    });
}
